module.exports = __webpack_public_path__ + "media/images/athletes/3555-7ad690bd28ea47ff4370bb2606109810.png";